var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EC826E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 11.2656C11.4286 11.3553 11.3574 11.4287 11.2704 11.4287L9.96538 11.4226L7.99998 9.0071L6.03656 11.4206L4.72959 11.4267C4.64259 11.4267 4.57141 11.3553 4.57141 11.2636C4.57141 11.2249 4.58525 11.1882 4.60898 11.1576L7.1814 7.9981L4.60898 4.84064C4.58509 4.81076 4.57183 4.77336 4.57141 4.73464C4.57141 4.64495 4.64259 4.57157 4.72959 4.57157L6.03656 4.57768L7.99998 6.99318L9.9634 4.57972L11.2684 4.57361C11.3554 4.57361 11.4266 4.64495 11.4266 4.73668C11.4266 4.77541 11.4127 4.8121 11.389 4.84267L8.82055 8.00014L11.393 11.1596C11.4167 11.1882 11.4286 11.2269 11.4286 11.2656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejectedIcon.1fea9f5756e3a80d2191f754f05f7834.svg";
export { ForwardRef as ReactComponent };